import React from "react";

import Hero from "../components/Home/Hero/Hero";
import FoodCategories from "../components/Home/FoodCategories/FoodCategories";
import BestSellers from "../components/Home/BestSellers/BestSellers";
import SushiGrid from "../components/Home/SushiGrid/SushiGrid";
import CallAndAsk from "../components/Home/CallAndAsk/CallAndAsk";
import FishWeek from "../components/Home/FishWeek/FishWeek";

export default function Home({ active, setActive }) {
  return (
    <>
      <Hero></Hero>
      <FoodCategories
        active={active}
        setActive={setActive}
      ></FoodCategories>
      <BestSellers></BestSellers>
      <FishWeek></FishWeek>
      <SushiGrid></SushiGrid>
      <CallAndAsk></CallAndAsk>
    </>
  );
}
